import { lazy } from 'react';

export const BimCalculationUpdate = lazy(() =>
    import('./BimCalculationUpdate').then((module) => ({ default: module.BimCalculationUpdate })),
);
